let errorListeners = [];

export const subscribeToErrors = (callback) => {
    errorListeners.push(callback);
    return () => {
        errorListeners = errorListeners.filter(listener => listener !== callback);
    };
};

export const notifyError = (message) => {
    errorListeners.forEach(listener => listener(message));
};

export const triggerExpSession = (value) => {
    errorListeners.forEach(listener => listener(value));
};
